export default __webpack_public_path__ + "static/media/login-background.1fb87daf.jpg";